import { cx } from '@twind/core';

import ExpandIcon from '../icons/ExpandIcon';

export default function ExpandButton({ onClick, className }: { onClick: () => void; className?: string }) {
  return (
    <button
      id="ostro-webchat-expand-button"
      aria-label="Close"
      className={cx('~(h-[44px] w-[44px] text-center flex items-center justify-center cursor-pointer)', className)}
      onClick={onClick}
    >
      <span className="rounded-full w-[27px] h-[27px] text-center flex items-center justify-center bg-neutral-200">
        <ExpandIcon className="fill-black w-3" />
      </span>
    </button>
  );
}
